import { ReactComponent as TodayIcon } from "../img/My-health/icon_today.svg";
import { ReactComponent as MyHealthIcon } from "../img/My-health/icon_health.svg";
import { ReactComponent as MyClinicIcon } from "../img/My-health/icon_clinic.svg";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

import createPersistedState from "use-persisted-state";
import { ReactComponent as ChatDoctorIcon } from "../img/icons/icon_chat_doctor.svg";
import { Badge } from "@material-ui/core";
import { Chat } from "@material-ui/icons";

const useProfileState = createPersistedState("profile");
const useTokenState = createPersistedState("token");

const getNewMessagesCountFromServer = async (userId, token) => {
  const MESSAGE_COUNT_URL = `/api/v1/chat/channel/${userId}/unread/count`;
  try {
    const response = await fetch(MESSAGE_COUNT_URL, {
      method: "GET",
      headers: {
        Accept: "application/json; charset=utf-8",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    });
    const data = await response.json();
    return data;
  } catch (err) {}
};

const checkAndUpdateNewMessageNotificationBadge = (
  userId,
  token,
  setNewMessageCount
) => {
  getNewMessagesCountFromServer(userId, token)
    .then((data) => {
      data.status.success && setNewMessageCount(data.count);
    })
    .catch((err) => {});
};

function BottomNav({ option, isChatButtonEnabled }) {
  const history = useHistory();
  const [currentOption, setOption] = useState(option ? option : "today");
  const { t } = useTranslation();
  const [profile, _] = useProfileState();
  const [token, __] = useTokenState();
  const NEW_MESSAGE_COUNT_POLL_INTERVAL = 15000;

  const clickHandler = (option, route) => {
    setOption(option);
    history.push(route);
  };

  const isActive = (optionCode) =>
    currentOption === optionCode ? "active" : "";

  const [newMessageCount, setNewMessageCount] = useState(0);

  useEffect(() => {
    profile != undefined &&
      checkAndUpdateNewMessageNotificationBadge(
        profile.patientId,
        token,
        setNewMessageCount
      );

    const intervalReference = setInterval(() => {
      profile != undefined &&
        checkAndUpdateNewMessageNotificationBadge(
          profile.patientId,
          token,
          setNewMessageCount
        );
    }, NEW_MESSAGE_COUNT_POLL_INTERVAL);

    return () => {
      clearInterval(intervalReference);
    };
  }, []);

  return (
    <>
      {profile?.chatEnabled && isChatButtonEnabled === true && (
        <Link
          to="/select-chat"
          style={{ position: "fixed", right: "15px", bottom: "80px" }}
        >
          <Badge
            badgeContent={newMessageCount}
            overlap="rectangle"
            color="secondary"
          >
            <div
              style={{
                backgroundColor: "var(--lightbluecolrtwenty)",
                borderRadius: "50%",
                width: 55,
                height: 55,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Chat
                style={{ color: "var(--darkbluecolortwo)", fontSize: 35 }}
              />
            </div>
          </Badge>
        </Link>
      )}
      <div className="navbar_fixed_bottom">
        <ul className="list-unstyled list_tab">
          <li>
            <a
              onClick={() => clickHandler("today", "/home")}
              className={isActive("today")}
            >
              <span className="icon">
                <TodayIcon className="img-fluid" />
              </span>
              <span className="txt">{t("login.BOTTOMNAV.today")}</span>
            </a>
          </li>
          <li>
            <a
              onClick={() => clickHandler("my-health", "/my-health")}
              className={isActive("my-health")}
            >
              <span className="icon">
                <MyHealthIcon className="img-fluid" />
              </span>
              <span className="txt">{t("login.BOTTOMNAV.health")}</span>
            </a>
          </li>
          <li>
            <a
              onClick={() => clickHandler("my-clinic", "/my-clinic")}
              className={isActive("my-clinic")}
            >
              <span className="icon">
                <MyClinicIcon className="img-fluid" />
              </span>
              <span className="txt">{t("login.BOTTOMNAV.clinic")}</span>
            </a>
          </li>
        </ul>
      </div>
    </>
  );
}

export default BottomNav;
